import { forwardRef, InputHTMLAttributes } from 'react'

import AppCheckbox from './AppCheckbox'
import { CheckboxGroupOption } from './AppCheckboxGroup.types'

type Props = InputHTMLAttributes<HTMLInputElement> & {
  options: CheckboxGroupOption[]
  title?: string
  className?: string
  dataTestId?: string
}

const AppCheckboxGroup = forwardRef<HTMLInputElement, Props>(
  ({ options, title, className, dataTestId, ...props }, ref) => {
    return (
      <div
        data-testid={dataTestId && `${dataTestId}-group-id`}
        className={className}
      >
        {title && (
          <div className="mb-8 font-sans text-black/50 text-16">{title}</div>
        )}
        <div className="flex flex-col gap-8">
          {options.map(option => (
            <AppCheckbox
              ref={ref}
              key={option.value}
              dataTestId={dataTestId && `${dataTestId}-${option.value}-id`}
              {...option}
              {...props}
            />
          ))}
        </div>
      </div>
    )
  }
)

AppCheckboxGroup.displayName = 'AppCheckboxGroup'
export default AppCheckboxGroup
